<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3b"><a id="page_1">GAIA</a></h3><a id="page_1">
<p class="noindent"><em><strong>Mary’s</strong> dead</em>. Maybe if I say it over and over a thousand times, it’ll sink in. <em>Mary’s dead</em>.</p>
<p class="indent">I’ve been sitting in this tub for more than an hour now. I’m shivering and the water’s cold, but I can’t seem to move. I keep seeing Mary’s face. Keep feeling her hair in my hands. There was blood on her teeth.</p>
<p class="indent"><em>Mary’s dead</em>. I held her tonight as her eyes closed. Her life flowed out onto the cobblestone pavement of Washington Square Park. I saw who did it. I even fought him. Mary’s old dealer, Skizz, hired that guy to kill Mary. Which he did, tonight.</p>
</a><p class="indent"><a id="page_1">Oh God, Mary’s really dead. She won’t call me tomorrow. I’m shaking and sore and Mary’s blood washed off into this bathwater when I stepped in. She won’t ever make me wear ridiculous clothes again. Make me go dancing with her. </a><a id="page_2">Tell me her secrets. Listen when I tell her mine.</a></p><a id="page_2">
<p class="indent">What do I do now? Everything I touch gets destroyed. What does that mean for Ed? I can’t seem to get out of this tub. I’m curled up. The porcelain is hard and cold under my head. I’m shaking. I don’t want to cry, can’t cry, can’t make noise. Don’t want Ella to come up here.</p>
<p class="indent"><em>Oh God, Mary’s dead</em>. Is it too much for me to have a friend? Is it too much for me to trust someone? Is it too much for me to be close to someone?</p>
<p class="indent">I need to think. Think this through. Thinking is better than screaming. Better than crying. Better than feeling all this <em>pain</em>. I can’t stand this pain. I don’t want to feel this. I’ve got to stop this.</p>
<p class="indent">Breathe, breathe, breathe.</p>
<p class="indent">Okay.</p>
<p class="indent">No more.</p>
</a><p class="indent"><a id="page_2">I have to find a way to never feel like this again. Not because </a><a id="page_3">of my mom, or my dad, or Mary, or anyone. I’ve got to make sure I never, never feel this pain again.</a></p><a id="page_3">
<p class="indent">And I’ve got to make Skizz pay.</p>
</a><p class="indent"><a id="page_3"></a><a id="page_4"></a></p><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?6d3dbb93